.container {
  background-image: url(src/assets/images/loading.png);
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  touch-action: none;
  position: fixed;
  width: 100%;
  z-index: 99999;
}
